import React from 'react';
import * as Yup from "yup";
import { sortCaret } from "../../../../_metronic/_helpers";
import * as columnFormatters from "../../../../_metronic/layout/components/basePage/pages/objects-table/column-formatters";
import { Input } from "../../../../_metronic/_partials/controls";
import { SelectObjectsField } from "../../../../_metronic/layout/components/basePage/selectObjects/SelectObjectsField";
import { SelectStatus } from "../../customComponents/SelectStatus";
import { FilterSelectObjectsField } from '../../../../_metronic/layout/components/basePage/selectObjects/FilterSelectObjectsField';


export const initObject = {
  id: undefined,
  title: "",
  genderCategoryId: 0,
  genderCategoryTitle: "",
  categoryId: 0,
  categoryTitle: "",
  townId: 0,
  townTitle: "",
  provinceId: 0,
  provinceTitle: "",
  adminUserId: 0,
  creatorUserId: 0,
  updaterUserId: 0,
  createAt: "",
  updateAt: "",
  code: "",
  phone: "",
  localPhone: "",
  description: "",
  status: 0,
  isDeleted: false
};


export const columns = [
  {
    dataField: "title",
    text: "عنوان",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "code",
    text: "کد",
    sort: true,
    sortCaret: sortCaret,
  },
  // {
  //   dataField: "provinceTitle",
  //   text: "استان",
  //   sort: true,
  //   sortCaret: sortCaret,
  // },
  {
    dataField: "townTitle",
    text: "استان/شهرستان",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "categoryTitle",
    text: "کاربری",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "genderCategoryTitle",
    text: "جنسیت",
    sort: true,
    sortCaret: sortCaret,
  },

  {
    dataField: "createAt",
    text: "تاریخ بهره برداری",
    sort: true,
    sortCaret: sortCaret,
    formatter: columnFormatters.DateColumnFormatter,
  },
  {
    dataField: "updateAt",
    text: "تاریخ تعمیر",
    sort: true,
    sortCaret: sortCaret,
    formatter: columnFormatters.DateColumnFormatter,
  },
  {
    dataField: "isDeleted",
    text: columnFormatters.translateByMessageId("MODULES.GENERAL.STATUS"),
    sort: true,
    sortCaret: sortCaret,
    formatter: columnFormatters.StatusColumnFormatter,
  },
  // {
  //   dataField: "action",
  //   text: columnFormatters.translateByMessageId("MODULES.GENERAL.ACTION"),
  //   // text: "Actions",
  //   formatter: columnFormatters.ActionsColumnFormatter,
  //   formatExtraData: {
  //     // openEditObjectPage: objectsUIProps.openEditObjectPage,
  //     // openDeleteObjectDialog: objectsUIProps.openDeleteObjectDialog,
  //   },
  //   classes: "text-right pr-0",
  //   headerClasses: "text-right pr-3",
  //   style: {
  //     minWidth: "100px",
  //   },
  // },
];

export const formFields = [
  {
    row: 1,
    list: [
      {
        name: "title",
        type: "text",
        component: Input,
        placeholder: "عنوان",
        label: "عنوان",
        rowIdx: 1,
        class: "col-lg-4"
      },
      {
        name: "categoryId",
        type: "option",
        component: (props) => <SelectObjectsField api="api/category"
          reduxState="placeCategories"
          sname="categoryId"
          label="کاربری" {...props} />,
        placeholder: "کاربری",
        label: "کاربری",
        rowIdx: 2,
        class: "col-lg-4"
      },
      {
        name: "genderCategoryId",
        type: "option",
        component: (props) => <SelectObjectsField api="api/category"
          reduxState="genderCategories"
          sname="genderCategoryId"
          label="جنسیت" {...props} />,
        placeholder: "جنسیت",
        label: "جنسیت",
        rowIdx: 3,
        class: "col-lg-4"
      },

    ]
  },
  {
    row: 2,
    list: [
      {
        name: "code",
        type: "text",
        component: Input,
        placeholder: "کد",
        label: "کد",
        rowIdx: 4,
        class: "col-lg-4"
      },
      {
        name: "provinceId",
        type: "select",
        component: (props) =>
          <SelectObjectsField api="api/province"
            reduxState="provinces"
            sname="provinceId"
            label="استان" {...props} />,
        placeholder: "استان",
        label: "استان",
        rowIdx: 5,
        class: "col-lg-4",
        relField: ["townId"],
        relValues: { townId: 0, townTitle: "" }
      },
      {
        name: "townId",
        type: "option",
        component: (props) => <SelectObjectsField api="api/town"
          reduxState="towns"
          sname="townId"
          label="شهرستان" {...props} />,
        placeholder: "شهرستان",
        label: "شهرستان",
        rowIdx: 6,
        class: "col-lg-4"
      },

    ]
  },
  {
    row: 3,
    list: [
      {
        name: "phone",
        type: "text",
        component: Input,
        placeholder: "تلفن",
        label: "تلفن",
        rowIdx: 7,
        class: "col-lg-4"
      }
    ]
  },
];

export const otherFields = [
  // {
  //   name: "description",
  //   lable: "Description",
  //   type: "textarea",
  //   as: "textarea",
  //   rowOrder: 1,
  //   rowIdx: 1,
  //   class: "form-control"
  // },

];




export const filterFields = [
  {
    name: "isDeleted",
    lable: "MODULES.GENERAL.STATUS",
    type: "select",
    list: [
      {
        value: "",
        lable: "MODULES.GENERAL.STATUSALL",
      },
      {
        value: "0",
        lable: "MODULES.GENERAL.STATUSENABLE",
      },
      {
        value: "1",
        lable: "MODULES.GENERAL.STATUSDELETED",
      },

    ],
    component: SelectStatus
  },
  {
    name: "provinceId",
    lable: "استان",
    type: "component",
    list: [],
    component: (props) =>
      <SelectObjectsField
        api="api/province"
        reduxState="provinces"
        sname="provinceId"
        {...props} />
  },
  {
    name: "categoryId",
    lable: "کاربری",
    type: "selectComponent",
    list: [],
    component: (props) =>
      <SelectObjectsField api="api/category"
        reduxState="placeCategories"
        sname="categoryId"
        {...props} />
  },
  {
    name: "genderCategoryId",
    lable: "جنسیت",
    type: "selectComponent",
    list: [],
    component: (props) => <SelectObjectsField api="api/category"
      reduxState="genderCategories"
      sname="genderCategoryId"
      {...props} />
  },
  {
    name: "searchText",
    lable: "MODULES.GENERAL.SEARCH",
    type: "text",
    list: [],
  },

];


export const filterInitialValues = {
  filter: {
    isDeleted: "", // values => All=""/Selling=0/Sold=1
    searchText: "",
    categoryId: 0,
    provinceId: 0,
    genderCategoryId: 0,
  },
  sortOrder: "asc", // asc||desc
  sortField: "id",
  pageNumber: 1,
  pageSize: 10,

  whereClause: "",
  whereClauseParameters: [
  ],
  orderClause: "id desc ",
  skipCount: 0,
  takeCount: 10,
};


export const prepareFilter = (queryParams, values) => {
  // const { isDeleted, searchText, categoryId, genderCategoryId } = values;
  const { isDeleted, searchText, categoryId, provinceId, genderCategoryId } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};
  // Filter by isDeleted
  if (isDeleted !== undefined)
    filter.isDeleted = isDeleted !== "" ? +isDeleted : undefined;

  // Filter by categoryId
  filter.categoryId = categoryId !== "" ? +categoryId : 0;

  // filter.provinceId = provinceId !== "" ? +provinceId : 0;
  filter.provinceId = provinceId !== "" ? +provinceId : 0;
  filter.genderCategoryId = genderCategoryId !== "" ? +genderCategoryId : 0;

  // Filter by all fields
  filter.title = searchText;
  if (searchText) {
    filter.title = searchText;
  }
  newQueryParams.filter = filter;

  let whereClause = ""
  const whereClauseParameters = [];

  var idx = 0;

  if (searchText !== "" && searchText !== undefined && idx === 0) {
    whereClause = `title.contains(@${idx})`
    whereClauseParameters.push(searchText)
    idx++;
  }
  else if (searchText !== "" && searchText !== undefined && idx > 0) {
    whereClause = whereClause + ` and title.contains(@${idx})`
    whereClauseParameters.push(searchText)
    idx++;
  }

  // if (filter.provinceId > 0 && idx === 0) {
  //   whereClause = `provinceId=@${idx}`
  //   whereClauseParameters.push(filter.provinceId)
  //   idx++;
  // }
  // else if (filter.provinceId > 0 && idx > 0) {
  //   whereClause = whereClause + ` and provinceId=@${idx}`
  //   whereClauseParameters.push(filter.provinceId)
  //   idx++;
  // }

  if (filter.categoryId > 0 && idx === 0) {
    whereClause = `categoryId=@${idx}`
    whereClauseParameters.push(filter.categoryId)
    idx++;
  }
  else if (filter.categoryId > 0 && idx > 0) {
    whereClause = whereClause + ` and categoryId=@${idx}`
    whereClauseParameters.push(filter.categoryId)
    idx++;
  }

  if (filter.genderCategoryId > 0 && idx === 0) {
    whereClause = `genderCategoryId=@${idx}`
    whereClauseParameters.push(filter.genderCategoryId)
    idx++;
  }
  else if (filter.genderCategoryId > 0 && idx > 0) {
    whereClause = whereClause + ` and genderCategoryId=@${idx}`
    whereClauseParameters.push(filter.genderCategoryId)
    idx++;
  }

  if (filter.isDeleted !== undefined && idx === 0) {
    whereClause = "isDeleted=@0";
    whereClauseParameters.push(filter.isDeleted === 0 ? false : true);
    idx++;
  }
  else if (filter.isDeleted !== undefined && idx > 0) {
    whereClause = whereClause + ` and isDeleted=@${idx}`
    whereClauseParameters.push(filter.isDeleted === 0 ? false : true);
    idx++;
  }

  newQueryParams.whereClause = whereClause;
  newQueryParams.whereClauseParameters = whereClauseParameters;

  return newQueryParams;
};


// Validation schema
export const ObjectEditSchema = Yup.object().shape({
  title: Yup.string()
    .required("پر کردن فیلد الزامی است"),
  categoryId: Yup.number()
    .positive("پر کردن فیلد الزامی است"),
  townId: Yup.number()
    .positive("پر کردن فیلد الزامی است"),
  // psp: Yup.number()
  //   .min(6, "6 is minimum")
  //   .max(18, "18 is maximum"),

});

